
























import { Component, Vue } from "vue-property-decorator";
import { Icon, Button, Toast } from "vant";
import _ from "lodash";

@Component({
  name: "Customer_payments_two",
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button
  }
})
// eslint-disable-next-line @typescript-eslint/class-name-casing
export default class Customer_payments_two extends Vue {
  isRead = false;
  readTime = 5;
  timer: any = null;
  isdetail: any = true;
  created() {
    this.initScroll()
  }
  activated() {
    
    if (this.$route.query.isdetails) {
      this.isdetail = this.$route.query.isdetails;
    } else {
      this.isdetail = true;
    }
    this.initScroll()
    // this.isRead = false;
    // const box7: any = document.getElementById("app");
    // this.$nextTick(() => {
    //   if(box7.scrollTo){
    //     box7.scrollTo(0,0)
    //   }else{
    //     box7.scrollTop = 0
    //   }
    //   
    //   
    //   box7.onscroll = null;
    //   let first = true;
    //   box7.onscroll = _.throttle(() => {
    //     
    //     const clientHeight = box7.clientHeight;
    //     const scrollTop = box7.scrollTop;
    //     const scrollHeight = box7.scrollHeight;
    //     
    //     
    //     if(first && scrollTop > 0){
    //       if(box7.scrollTo){
    //         box7.scrollTo(0,0)
    //       }else{
    //         box7.scrollTop = 0
    //       }
    //       first = false
    //     }
    //     
    //     if (scrollTop + clientHeight + 10 >= scrollHeight) {
    //       this.isRead = true;
    //     }
    //   }, 100);
    // });
    
    // this.timer = setInterval(() => {
    //   if (this.readTime > 1) {
    //     this.readTime--;
    //   } else {
    //     this.isRead = true;
    //     this.readTime = 5;
    //     clearInterval(this.timer);
    //   }
    // }, 1000);
  }

  deactivated() {
    const box: any = document.getElementById("app");
    box.onscroll = null;
    // this.timer && clearInterval(this.timer);
  }

  initScroll(){
    this.isRead = false;
    this.$nextTick(() => {
      const box: any = document.getElementById("app");
      if(box.scrollTo){
        box.scrollTo(0,0)
      }else{
        box.scrollTop = 0
      }
      
      
      box.onscroll = null;
      let first = true;
      box.onscroll = _.throttle(() => {
        
        if((first && box.scrollTop > 0) || (this.$route.path !== location.pathname)){
          if(box.scrollTo){
            box.scrollTo(0,0)
            
          }else{
            box.scrollTop = 0
          }
          first = false
        }
        const clientHeight = box.clientHeight;
        const scrollTop = box.scrollTop;
        const scrollHeight = box.scrollHeight;
        
        
        
        if (scrollTop + clientHeight + 10 >= scrollHeight) {
          this.isRead = true;
        }
      }, 100);
    });
  }

  isScrollBottom() {}

  handleNext() {
    if (!this.isRead) {
      return Toast(this.$t("open_account.risk_disclosure.toast_fail_text"));
    }
    this.$router.push({
      path: "/customer_payments_three",
      query: this.$route.query
    });
    setTimeout(()=>{
      const box: any = document.getElementById("app");
      if(box.scrollTo){
        box.scrollTo(0,0)
      }else{
        box.scrollTop = 0
      }
    },0)
  }
}
